import styled from 'styled-components'
import { Color } from './type'
import { HeightClass } from '~/utils/enum/classes'

export const BreadcrumbWrapper = styled.div`
  display: flex;
`

export const Breadcrumb = styled.div<{
  active: boolean
  color: Color
  heightClass: HeightClass
}>`
  font-family: Barlow;
  font-size: ${({ theme, heightClass }) =>
    theme.breadcrumb.sizes[heightClass]?.size};
  font-style: normal;
  font-weight: ${({ active }) => (active ? '600' : '400')};
  line-height: ${({ theme, heightClass }) =>
    theme.breadcrumb.sizes[heightClass]?.lineHeight};
  letter-spacing: 0.15px;
  color: ${({ color, theme }) => theme.breadcrumb.colors[color]};
  cursor: pointer;
`

export const Link = styled.a`
  text-decoration: none;

  :focus {
    border-bottom: 2px solid #abbed1;
    outline: none;
  }

  :hover {
    text-decoration: none;
  }
`

export const StyledSeparator = styled.div<{
  color: Color
  heightClass: HeightClass
}>`
  font-family: Barlow;
  font-size: ${({ theme, heightClass }) =>
    theme.breadcrumb.sizes[heightClass]?.size};
  font-style: normal;
  line-height: ${({ theme, heightClass }) =>
    theme.breadcrumb.sizes[heightClass]?.lineHeight};
  line-height: 24px;
  letter-spacing: 0.15px;
  align-self: center;
  color: ${({ color, theme }) => theme.breadcrumb.colors[color]};
  margin: 0
    ${({ heightClass, theme }) =>
      theme.breadcrumb.sizes[heightClass]?.spaceBetween};
`
